import React from 'react';
import {
    Container, Row, Col,
} from 'react-bootstrap';
import logoImage from './../assets/images/logo.png';
import logosImage from './../assets/images/logos.png';
import {
    Link,
} from 'react-router-dom';

const Header = () => {
    return (
        <header>
            <Container fluid>
                <Container>
                    {/* --- FIX: Updated columns for better mobile layout --- */}
                    <Row className='align-items-center'>

                        {/* This column is now full-width on mobile (xs=12) and centered. */}
                        <Col xs={12} md={4} className="text-center text-md-start">
                            <div className='logo'>
                                <Link to="/"><img src={logoImage} alt='logo' /></Link>
                            </div>
                        </Col>

                        {/* This column is now HIDDEN on mobile (d-none) and only shows on desktop (d-md-block) */}
                        <Col md={8} className="d-none d-md-block">
                            <div className='header-right text-end'>
                                <img src={logosImage} alt='logo' />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </header>
    )
}

export default Header;